import { Translate } from "components/common/Translate/Translate";
import { useEffect } from "react";
import { ColorScheme } from "../../useColorHarmonies";

interface TabProps {
    tab: ColorScheme;
    activeTab: ColorScheme;
    handleClick: () => void;
    translationKeyName: string;
}

export const Tab = ({ tab, activeTab, handleClick, translationKeyName }: TabProps) => {
    function handleActiveTabChange() {
        if (tab === activeTab) handleClick();
    }
    useEffect(handleActiveTabChange, [activeTab]);
    return (
        <div
            className={`cursor-pointer px-3 py-2 ${
                activeTab !== tab && "text-irGray-600 dark:text-darkSurface-600 font-semibold"
            } ${activeTab === tab && "bg-irGray-200 dark:bg-darkSurface-200"} rounded-xl whitespace-nowrap`}
            onClick={handleClick}
            data-testid={`${tab}-tab`}
        >
            <Translate keyName={translationKeyName} />
        </div>
    );
};
